/**
 * Created by akirilyuk on 08/02/17.
 * model responsible for loading and storing service interruption notifications
 *
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var LEResourceResolver = require("leResourceResolver");

    var ServiceStatusModel = {};
    var KEYS = {
        HEALTHY : "OK"
    };
    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        ServiceStatusModel = BaseModel.extend({
            resource: LEResourceResolver.apiResources.ServiceStatusDashboard.Status,

            initialize: function () {
                this.resource.url = LEResourceResolver.getUrl(LEResourceResolver.apiResources.ServiceStatusDashboard.Status);
                this.healthUrl = LEResourceResolver.getUrl(LEResourceResolver.apiResources.ServiceStatusDashboard.HealthPage);
            },

            parse: function(response){
                if(response){
                    this._setHealth(response);
                }
            },

            _setHealth: function(data){
                this.healthy = !_.some(data,function(current){
                    return current!==KEYS.HEALTHY;
                });
            },

            isHealthy: function(){
                return this.healthy;
            },

            getHealthUrl: function(){
                return this.healthUrl;
            }
        });
    });
    ServiceStatusModel.KEYS = KEYS;
    return ServiceStatusModel;
});
